export default __webpack_public_path__ + "static/media/angle-light.098d53ab.svg";